import { useEffect, useState } from 'react';
import { base44 } from '@/api/base44Client';
import { useSeo } from '@/lib/seo';

/**
 * Fetches a SiteSeo override for the given page key and applies it on top of
 * the provided defaults (title/description), keeping any other SEO fields
 * (image, jsonLd, etc.) from defaults.
 */
export function useSiteSeo(pageKey, defaults = {}) {
  const [override, setOverride] = useState(null);

  useEffect(() => {
    let active = true;
    setOverride(null);
    base44.entities.SiteSeo.filter({ page_key: pageKey })
      .then((rows) => {
        if (active && rows && rows[0]) setOverride(rows[0]);
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, [pageKey]);

  useSeo({
    ...defaults,
    title: override?.seo_title || defaults.title,
    description: override?.seo_description || defaults.description,
  });
}